import { FormattedMessage } from "react-intl";
import CardInfo from "../CardInfo";
import Container from "./Container";
import { Col, Row } from "antd";

const FirstBlock = ({ happyPatient, percentageDmPatient }) => {
  const children = (
    <>
      <Row align={"middle"}>
        <Col span={6}>
          <img src="/images/img-1.svg" alt="img" />
        </Col>
        <Col className="roi--patient-exp-acq-text" span={9}>
          <span className="roi--patient-exp-acq-percentage">
            {percentageDmPatient}%
          </span>
          <span>
            <FormattedMessage id="patientFeedbackPourcentage" />
          </span>
        </Col>
        <Col span={9}>
          <CardInfo
            mainNumber={happyPatient}
            bottomText={<FormattedMessage id="patientFeedbackNumber" />}
          />
        </Col>
      </Row>
    </>
  );
  return (
    <Container
      blockTitle={"didyouknow"}
      title={"why"}
      content={"patientFeedbackinfo"}
      children={children}
    />
  );
};

export default FirstBlock;
